// Ordall PWA runtime configuration.
// Values baked in at build time.
//
// API base URL comes from VITE_API_BASE_URL when set at build time, falling
// back to the raw APIGW hostname. Phase 4 wires the toggle; Phase 5 will
// flip the default to https://api.stampmats.com once the custom domain has
// been production-verified.

const apiBaseUrl =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ??
  "https://12dsh0jydj.execute-api.eu-west-1.amazonaws.com";

export const CONFIG = {
  api: apiBaseUrl,
  cognito: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_vWb1fUD22",
    userPoolClientId: "2qci2fo17u2qvj1eskp7kcho6n",
  },
  brand: {
    name: "Ordall",
    tagline: "Digital evidence that survives.",
  },
};
